<script setup lang="ts">
import { ref } from 'vue'

const customizeVisible = ref(false)
</script>
<template>
  <el-popover placement="top" :width="280" trigger="hover">
    <p leading-7 text-main>
      {{ $t('me.storage_overflow_not_member') }}
      <router-link to="/member" user-link>{{ $t('action.buy_member') }}&gt;</router-link>
    </p>
    <template #reference>
      <span p-1 hover:bg-base rounded-1 mr-1>
        <div i-mingcute:warning-fill text-lg text-danger />
      </span>
    </template>
  </el-popover>
</template>
<style lang="scss" scoped></style>
